interface CustomTestSettingsProps {
  value: string
  setValue: (str: string) => void
}

const CustomTestSettings: React.FC<CustomTestSettingsProps> = ({
  value,
  setValue,
}) => {
  return (
    <>
      <div className="text-white font-fourth text-lg whitespace-nowrap">
        Test settings
      </div>
      <input
        className="z-10 w-40"
        data-testid="test.game-settings"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      ></input>
    </>
  )
}

export default CustomTestSettings
